import { useMutation, useQueryClient } from "@tanstack/react-query";
import useFetch from "../lib/useFetch";

const API = process.env.REACT_APP_API;

interface BulkDeleteParams {
  fairId: number;
  ids?: number[];
  producerId?: number;
}

const useBulkDeleteProductOfferings = () => {
  const queryClient = useQueryClient();
  const fetch = useFetch();

  return useMutation({
    mutationFn: ({ fairId, ids, producerId }: BulkDeleteParams) => {
      return fetch(
        `${API}/api/semeadora/fairs/${fairId}/offerings/bulk-delete/`,
        {
          method: "DELETE",
          body: {
            ids,
            producer_id: producerId,
          },
        },
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["product-offerings"] });
    },
    onError: (error) => {
      console.log("onError", error);
    },
  });
};

export default useBulkDeleteProductOfferings;
